var map = {
	"./1.svg": "a6bb",
	"./2.svg": "3c72",
	"./3.svg": "b595",
	"./4.svg": "3634",
	"./bg1.svg": "ab2b",
	"./bg2.svg": "f1a1",
	"./center.svg": "c92e",
	"./forward.svg": "3b0c",
	"./goalkeeper.svg": "4f6c",
	"./guard.svg": "e6cd",
	"./staffPosition.svg": "1eca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "176f";